module.exports = {
  strings: {
    pluginNameOneDrive: 'OneDrive'
  }
};